import { useParams } from 'react-router-dom';
import { RenderIf } from 'react-rainbow-components';
import { ChatUI } from '@voxityai/chat-ui';
import useUserRoles from 'hooks/useUserRoles';
import SmsNotifications from 'components/SmsNotifications';
import { User } from 'data/firestore/user/types';
import useTwilioConversation from 'hooks/useTwilioConversation';
import ActivePhoneCalls from 'components/ActivePhoneCalls';
import VoxityAppSwitcher from 'components/VoxityAppSwitcher';
import { auth } from 'data/firestore/firebase';
import useHttpQuery from 'data/firestore/useHttpQuery';
import AppMessage from 'components/AppMessage';
import { SubscriptionSummary } from 'types';
import useChatUserViewContext from 'hooks/useChatUserViewContext';
import NotificationsMenu from './NotificationsMenu';
import Agents from './agents';
import Avatar from './avatar';
import { Container, RightSection } from './styled';

const WIDGET_URL = process.env.REACT_APP_CHAT_UI_WIDGET_URL;

const TopBar = () => {
    const { agentId = '' } = useParams();
    const { user, isAdmin } = useUserRoles();
    const { isSMSEnabled } = useTwilioConversation();
    const organizationId = agentId;
    const baseUrl = process.env.REACT_APP_ACTIONS_BASE_URL || '';
    const userViewContext = useChatUserViewContext();

    const {
        data: subscriptionSummary,
    } = useHttpQuery<SubscriptionSummary>({
        pathname: `/agents/${agentId}/subscription`,
        queryOptions: {
            enabled: Boolean(agentId),
        },
    });

    const { status: subscriptionStatus } = subscriptionSummary || {};

    return (
        <Container>
            <Agents user={user as User} isAdmin={isAdmin} />
            <RenderIf isTrue={subscriptionStatus === 'past_due'}>
                <AppMessage variant="error">
                    Your subscription is past due.
                    Please contact us to solve this issue.
                </AppMessage>
            </RenderIf>
            <RightSection>
                <ActivePhoneCalls agentId={agentId} />
                <RenderIf isTrue={isSMSEnabled}>
                    <SmsNotifications agentId={agentId} />
                </RenderIf>
                <NotificationsMenu agentId={agentId} />
                <RenderIf isTrue={Boolean(baseUrl && organizationId)}>
                    <ChatUI
                        auth={auth}
                        server={baseUrl}
                        namespace="console"
                        organizationId={organizationId}
                        userViewContext={userViewContext}
                        widgetUrl={WIDGET_URL}
                    />
                </RenderIf>
                <VoxityAppSwitcher />
                <Avatar user={user as User} />
            </RightSection>
        </Container>
    );
};

export default TopBar;
